import { isBeta, isGamma, isLocal, isProd } from 'src/utils/detectEnv';

const AUSTIN_BETA_BASE_URL = 'na-beta.austin.a2z';
const AUSTIN_GAMMA_BASE_URL = 'na-gamma.austin.a2z';
const AUSTIN_PROD_BASE_URL = 'na.ehs-amazon';
const getEnvironment = () => {
  if (isLocal() || isBeta()) {
    return AUSTIN_BETA_BASE_URL;
  }
  if (isGamma()) {
    return AUSTIN_GAMMA_BASE_URL;
  }
  if (isProd()) {
    return AUSTIN_PROD_BASE_URL;
  }
  return AUSTIN_PROD_BASE_URL;
};
const baseUrl = getEnvironment();

export const constructIncidentLink = (caseId: string) => {
  return `https://${baseUrl}.com/incidents/incident/${caseId}`;
};

export const constructMedicalAttachmentsLink = (caseId: string) => {
  return `https://${baseUrl}.com/incidents/incident/${caseId}/medical_attachments`;
};

// Rosie has no gamma environment as far as I can tell.
const ROSIE_BETA_DOMAIN = 'beta.rosie.whs.amazon.dev';
const ROSIE_PROD_DOMAIN = 'rosie.whs.amazon.dev';

const getRosieDomainForEnvironment = () => {
  if (isProd()) {
    return ROSIE_PROD_DOMAIN;
  }
  return ROSIE_BETA_DOMAIN;
};

export const constructRosieCaseLink = (austinCaseNumber: string) => {
  const rosieDomainForEnvironment = getRosieDomainForEnvironment();
  return `https://${rosieDomainForEnvironment}/cases/${austinCaseNumber}?type=case-number`;
};
